import axios from "axios";

const apiBaseURL =
  process.env.REACT_APP_API_URL ||
  "https://api.glubes.tomko.mn/";

const instance = axios.create({
  baseURL: apiBaseURL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json; charset=UTF-8",
  },
});

instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('glubesAppToken');
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// const cloudfrontInstance = axios.create({
//   baseURL: "https://d16e7sptwljulm.cloudfront.net/",
//   headers: {
//     'Accept': 'application/json',
//     "Content-type": "application/json; charset=UTF-8",
//   },
// });

export { instance };

